<template>
  <div class="tips">
    <img class="img" src="../../../static/img/login/icon_login_tips.png">
    <span class="msg">{{ this.msg + ' : )' }}</span>
  </div>
</template>

<script>
export default {
  name: 'AlertItem',
  props: {
    msg: {
      type: String,
      default: ''
    },
    dataIndex: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    // 3000ms后关闭该弹窗
    setTimeout(() => this.$store.commit('close_alert', this.dataIndex), 3000)
  },
}
</script>

<style lang="less" scoped>
.tips {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  background-color: #000000;
  border-radius: 30px;
  opacity: .5;
  padding: 10px 0;
  .img {
    width: 30px;
    height: 30px;
  }
  .msg {
    display: inline-block;
    font-size: 18px;
    color: #fefefe;
    margin-left: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/alert_item.vue